export const GET_BANNER='GET_BANNER'
export const GET_CAPTION='GET_CAPTION'